<template>
  <s-modal-card class="md-modal">
    <template slot="title">
      <template v-if="object_name === 'Operation Log'">
        {{ `${object_name}` }}
      </template>
      <template v-else>
        {{ `(${object_id}) ${object_name}` }}
      </template>
    </template>
    <div slot="body">
      <table class="table small border white-space-normal">
        <thead>
          <tr>
            <th width="120px">Time</th>
            <th width="80px">User</th>
            <th>Type</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!log_list.length">
            <td colspan="4" class="text-center">No Data!</td>
          </tr>
          <tr v-for="(row, index) in log_list" :key="index">
            <td>{{ row.action_time }}</td>
            <td>{{ row.user_name }}</td>
            <td>{{ row.event_name }}</td>
            <td>{{ row.message }}</td>
          </tr>
        </tbody>
      </table>
      <Pagination class="mt-2" :page="pageInfo" :change="getList" />
    </div>
    <div slot="footer"></div>
  </s-modal-card>
</template>

<script type="text/babel">
import Pagination from './Pagination'

export default {
  name: 'log',
  data() {
    return {
      pageInfo: {
        cur: 1,
        per: 10,
        tot: 0,
      },

      log_list: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(page_current) {
      let params = {
        p: page_current || 1,
        n: this.pageInfo.per,
        object_id: this.object_id,
        object_name: this.object_field,
        model: this.model,
        event_group: this.event.length > 0 ? undefined : this.event_group,
        event: this.event,
        and_or: this.and_or || 0,
      }
      for (let i in this.search) {
        params[i] = this.search[i]
      }
      this.$http
        .get('/api/logs/', {
          params: params,
        })
        .then(res => {
          this.log_list = res.data

          this.changePageItem(this.pageInfo, res)
        })
    },
  },
  props: {
    object_id: [Object, Number],
    object_name: [Object, String],
    object_field: [Object, String],
    model: [Object, String],
    event_group: [Object, Number],
    and_or: [Object, Number],
    event: {
      type: Array,
      default() {
        return []
      },
    },
    search: Object,
  },
  components: {
    Pagination,
  },
}
</script>
